import {
  ISalePageDetailResponseProduct,
  ISalePageProductAdditionalInformResponse,
} from '@/api/types';
import {
  useProductAdditionalInforms,
  useSalePageQuery,
} from '@/entities/salePage';
import { useMemo } from 'react';

export type ProductItemWithAdditionalInfo = ISalePageDetailResponseProduct &
  Partial<ISalePageProductAdditionalInformResponse>;

/**
 * 판매 페이지의 상품 목록과 구매 가능 여부(additionalInforms)를 병합하여 반환.
 * additionalInforms는 로그인 상태에서만 fetch되며,
 * 각 상품의 사용자별 구매 가능 수량과 구매 가능 여부 등을 포함한다.
 */
export const useProductItemList = (salePageId: number) => {
  const { data } = useSalePageQuery(salePageId);
  const { data: productAdditionalInforms } =
    useProductAdditionalInforms(salePageId);

  const itemList = useMemo(() => {
    const informMap = new Map(
      productAdditionalInforms?.map(info => [info.productId, info]) ?? []
    );
    return (
      data?.products?.map(product => ({
        ...product,
        ...informMap.get(product.id),
      })) || ([] as ProductItemWithAdditionalInfo[])
    );
  }, [data?.products, productAdditionalInforms]);

  return { data, itemList, productAdditionalInforms };
};
